import $ from 'jquery';
Window.prototype.$ = $;
import { debounce } from 'underscore';
import CounterAnimation from './classes/counter-animation';
import Form from './classes/form';
import IsInViewport from './classes/is-in-viewport';
import SimpleDropzone from './classes/simple-dropzone';
import DownloadPortal from './classes/download-portal';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/collapse';
import Accordion from './classes/accordion';
import HistorySlider from './classes/history-slider';
import JobDetail from './classes/job-detail';
import JobHighlight from './classes/job-highlight';
import Slider from './classes/slider';
import TeaserGroupSlider from './classes/teaser-group-slider';
import CirculeeIntroLayout from './classes/circulee-intro-layout';
import LinkedinFeedSlider from './classes/linkedin-feed-slider';

export default class Application {
	constructor() {
		this.isInViewport = new IsInViewport(
			$('.counter-wrapper, .count').toArray(),
		);
		this.isPartiallyInViewport = new IsInViewport(
			$('.animate__animated').toArray(),
			10,
		);
		this.counterAnimation = new CounterAnimation();
		this.simpleDropzone = new SimpleDropzone();
		this.downloadPortal = new DownloadPortal();
		this.jobDetail = new JobDetail();
		this.form = new Form();
		this.historySlider = new HistorySlider();
		this.accordion = new Accordion();
		this.slider = new Slider();
		this.jobHighlight = new JobHighlight();
		this.teaserGroupSlider = new TeaserGroupSlider();
		this.circuleeIntroLayout = new CirculeeIntroLayout();
		this.linkedinFeedSlider = new LinkedinFeedSlider();

		document.addEventListener('isInViewport', (event) => {
			// (1)
			const currentElement = $(event.target);
			if (currentElement.hasClass('count')) {
				this.counterAnimation.startAnimation(currentElement);
				document.removeEventListener('isInViewport', event);
			}

			const animationClass = currentElement.data('animation');
			if (typeof animationClass !== 'undefined') {
				currentElement.addClass(animationClass);
				document.removeEventListener('isInViewport', event);
			}
		});
	}

	myCalculator(num1, num2, myCallback) {
		const sum = num1 + num2;
		myCallback(sum);
	}

	init() {
		this.initStickyHeaderListener();
		this.toggleNestedNaviDropDown();
		this.isInViewport.update();
		this.isPartiallyInViewport.update();
		this.simpleDropzone.init();
		this.downloadPortal.init();
		this.jobDetail.init();
		this.form.init();
		this.historySlider.init();
		this.accordion.init();
		this.slider.init();
		this.jobHighlight.init();
		this.teaserGroupSlider.init();
		this.circuleeIntroLayout.init();
		this.linkedinFeedSlider.init();
	}

	initStickyHeaderListener() {
		const stickyHeader = $('.sticky-header').closest('.header');
		window.addEventListener(
			'scroll',
			() => {
				if (window.pageYOffset > 150) {
					if (!stickyHeader.hasClass('active') && $(window).width() > 992) {
						stickyHeader.addClass('active');
					}
				} else {
					if (stickyHeader.hasClass('active')) {
						stickyHeader.removeClass('active');
					}
				}
			},
			{ passive: true },
		);

		$('.navbar-toggler.burger-menu').on('click', () => {
			$('.header-desktop').toggleClass('keep-active');
		});
	}

	toggleNestedNaviDropDown() {
		$(".header-menu-mobile .dropdown-menu [data-bs-toggle='dropdown']").on(
			'click',
			(event) => {
				event.preventDefault();
				event.stopPropagation();
			},
		);
	}

	// On resize Window
	responsive() {
		this.isInViewport.update();
		this.isPartiallyInViewport.update();
		this.initStickyHeaderListener();
		this.slider.adjustDotsForMobile();
		this.jobHighlight.adjustBackgroundHeight();
	}

	scroll() {
		// console.log(window);
		this.isInViewport.update();
		this.isPartiallyInViewport.update();
	}

	startGaOptout() {
		if (typeof gaOptout === 'function') {
			$('.ga-optout').on('click', () => {
				gaOptout();
			});
		}
	}
}

$(document).ready(() => {
	const application = new Application();
	const win = $(window);
	application.init(win);

	win.resize(
		debounce(() => {
			application.responsive(win);
		}, 250),
	);

	win.scroll(() => {
		application.scroll(win);
	});

	application.startGaOptout();
});
